/**
 * Labstep
 *
 * @module components/ProtocolValue/Detail
 * @desc Detail for Experiment Value
 */

import { ProtocolValueDetailAmount } from 'labstep-web/components/ProtocolValue/Detail/Amount';
import { ProtocolValueDetailResourceItem } from 'labstep-web/components/ProtocolValue/Detail/ResourceItem';
import { ProtocolValueDetailSettings } from 'labstep-web/components/ProtocolValue/Detail/Settings';
import type { IProtocolValueDetailProps } from 'labstep-web/components/ProtocolValue/Detail/types';
import { ProtocolValueVariableDetail } from 'labstep-web/components/ProtocolValue/Variable/Detail';
import { Divider } from 'labstep-web/core/Divider';
import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';

export const ProtocolValueDetail: React.FC<
  IProtocolValueDetailProps
> = ({ protocolValue, read }) => (
  <Flex column grow data-cy="components/ProtocolValue/Detail">
    <ProtocolValueDetailSettings protocolValue={protocolValue} />
    <Divider />
    {protocolValue.is_variable ? (
      <ProtocolValueVariableDetail
        protocol={protocolValue.parent}
        protocolValue={protocolValue}
        read={read}
      />
    ) : (
      <>
        <ProtocolValueDetailAmount protocolValue={protocolValue} />
        <Divider />
        <ProtocolValueDetailResourceItem
          protocolValue={protocolValue}
        />
      </>
    )}
  </Flex>
);
